var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/profile_selected.0b1c83c5.png","uri@3x": __webpack_public_path__ + "static/media/profile_selected.caff8315.png","uri@2x": __webpack_public_path__ + "static/media/profile_selected.0acd41f3.png",
    width: 24,
    height: 24
});